import { Component } from "@angular/core";
import { AbstractModalComponent } from "../shared/modal/abstract-modal.component";
import { UserAPI } from "../../model";
import { SharedModule } from "../shared/shared.module";
import { UserApiModalModule } from "./userapi-modal.module";

@Component({
  selector: 'app-userapi-modal',
  imports: [SharedModule, UserApiModalModule],
  templateUrl: './userapi-modal.component.html'
})
export class UserApiModalComponent extends AbstractModalComponent {

  userApi: UserAPI;

}
